import { render, staticRenderFns } from "./_InvitationDialog.vue?vue&type=template&id=9674c11a&scoped=true&"
import script from "./_InvitationDialog.vue?vue&type=script&lang=js&"
export * from "./_InvitationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9674c11a",
  null
  
)

export default component.exports